import {
    KinesisVideoSignalingClient,
    GetIceServerConfigCommand,
} from "@aws-sdk/client-kinesis-video-signaling";
import { IKvsClientConfig } from "../types/kinesis";


export class KinesisVideoSignalingClientService {
    private client: KinesisVideoSignalingClient;


    constructor(config: IKvsClientConfig) {
        this.client = new KinesisVideoSignalingClient(config);
    }


    async getIceServerConfig(channelARN: string) {
        try {
            const command = new GetIceServerConfigCommand({ ChannelARN: channelARN });
            const response = await this.client.send(command);
            return response;
        } catch (error) {
            // notification.error({
            //     message: "Error",
            //     description: "Error getting ICE server config:",
            // });
            console.error("Error getting ICE server config:", error);
            throw error;
        }
    }
}
